/**
 * Toast — lightweight notification utility.
 * Renders a brief on-screen message that auto-dismisses.
 * Usage: Toast.show('Quest accepted!', { type: 'success', duration: 2500 })
 */

const Toast = {
  /**
   * Show a toast notification.
   * @param {string} message
   * @param {object} [opts]
   * @param {'info'|'success'|'warn'|'error'} [opts.type='info']
   * @param {number} [opts.duration=2200] — ms before auto-dismiss
   */
  show(message, opts = {}) {
    const { type = 'info', duration = 2200 } = opts;

    const el = document.createElement('div');
    el.className = 'sr-toast';
    el.textContent = message;

    // Color accent by type
    const accent = {
      success: '#40a060',
      warn:    '#c8a020',
      error:   '#c83020',
      info:    'rgba(200, 160, 32, 0.4)',
    }[type] ?? 'rgba(200, 160, 32, 0.4)';

    el.style.borderColor = accent;

    const mount = document.getElementById('ui-overlay') ?? document.body;
    mount.appendChild(el);

    const dismiss = () => {
      el.classList.add('sr-toast-out');
      setTimeout(() => el.remove(), 350);
    };

    setTimeout(dismiss, duration);
  },
};

export default Toast;
